import { Controller } from '@hotwired/stimulus'
import flatpickr from 'flatpickr'

// A settings date field: clicking the field or its calendar icon opens flatpickr. Guests read "Thu, Oct 1, 2026";
// the form posts YYYY-MM-DD. Changes are announced so live previews repaint.
export default class extends Controller {
  static targets = ['input']

  connect() {
    this.picker = flatpickr(this.inputTarget, {
      altInput: true,
      altFormat: 'D, M j, Y',
      dateFormat: 'Y-m-d',
      disableMobile: true,
      onChange: () => {
        this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
        this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
      }
    })
  }

  open() {
    this.picker.open()
  }

  disconnect() {
    this.picker?.destroy()
  }
}
